import { Link } from "react-router-dom";

export default function PublicNav() {
  return (
    <nav
      data-testid="public-nav"
      className="sticky top-0 z-40 w-full backdrop-blur-md bg-background/60 border-b border-border/60"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-4 flex items-center justify-between">
        <Link to="/" data-testid="nav-home-link" className="flex items-center gap-2">
          <div className="w-8 h-8 overflow-hidden flex items-center justify-center bg-transparent shrink-0">
            <img src="/public-nav-coffee.png?v=20260725-0208" alt="" aria-hidden className="w-full h-full object-contain" />
          </div>
          <span className="font-display text-xl leading-none">
            Okay <em className="italic font-light">Room</em>
          </span>
        </Link>
      </div>
    </nav>
  );
}
